<template>
  <v-card class="px-2 py-1" v-bind="$attrs">
    <v-row dense class="align-center">
      <v-col cols="auto" class="d-sm-none d-md-block">
        <v-btn fab text small :title="showFiltersMsg" @click="onShowFiltersClick" >
          <v-icon v-if="!showFilters">mdi-filter</v-icon>
          <v-icon v-if="showFilters">mdi-filter-off-outline</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="auto">
        <v-menu v-model="showSettings" :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab text small title="Configurar" v-bind="attrs" v-on="on">
              <v-icon>mdi-cog</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-select
                    v-model="sortCol"
                    :menu-props="{ offsetY: true }"
                    style="max-width:10rem;"
                    outlined
                    hide-details
                    dense
                    :items="sortFields"
                    item-text="text"
                    item-value="id"
                    label="Ordenar por"
                  />
                </v-list-item>

                <v-divider class="my-2" />

                <v-list-item>
                  <v-checkbox
                    v-model="newDescOrder"
                    class="mt-0"
                    hide-details
                    label="Ordenação descendente"
                  />
                </v-list-item>

                <v-divider class="my-2" />

                <v-list-item>
                  <v-select
                    v-model="newPageSize"
                    style="max-width:9rem;"
                    :menu-props="{ offsetY: true }"
                    dense
                    outlined
                    hide-details
                    :items="pagingSizes"
                    label="Itens por página"
                  />
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-col>

      <v-col cols="auto">
        <tj-view-mode-selector :value="viewMode" :itens="viewModes" @update="onViewMode" />
      </v-col>

      <v-col class="text-center  white--text black rounded-lg px-3" cols="auto">
        <span v-if="theTotal" class="text-caption">
          Exibindo
          <span v-if="oneItem">
            item <b>{{ first }}</b>
          </span>
          <span v-if="!oneItem">
            itens <b>{{ first }}</b> a <b>{{ last }}</b>
          </span>
          de {{ theTotal }}
        </span>
        <span v-if="!theTotal" class="text-caption">
          Nenhum item disponível
        </span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Vue from "vue";
import "@/components/tj-view-mode-selector.vue"

export default Vue.component("tj-info-bar", {
  props: {
    sortBy: String,
    sortOrder: String,
    total: Number,
    pageSize: Number,
    page: Number,
    viewMode: String,
    showFilters: Boolean,
    pagingSizes: Array,
    sortFields: Array,
    viewModes: Array,
  },

  data() {
    return {
      showSettings: false
    };
  },

  computed: {
    sortCol: {
      get() {
        return this.sortBy || "";
      },
      set(v) {
        this.$emit("update:sort-by", v);
        this.showSettings = false;
      }
    },

    newDescOrder: {
      get() {
        return this.sortOrder === "desc";
      },
      set(v) {
        const order = v ? "desc" : "asc";
        if (order !== this.sortOrder) this.$emit("update:sort-order", order);
        this.showSettings = false;
      }
    },

    newPageSize: {
      get() {
        return this.thePageSize;
      },
      set(v) {
        const pg =
          this.pagingSizes[Math.max(0, this.pagingSizes.indexOf(v))] ||
          this.pagingSizes[0];
        this.$emit("update:page-size", pg);
        this.showSettings = false;
      }
    },

    thePageSize() {
      return Math.max(1, +this.pageSize || 0);
    },

    thePage() {
      return Math.max(1, +this.page || 0);
    },

    theTotal() {
      return Math.max(0, +this.total || 0);
    },

    first() {
      const p = this.thePage;
      const s = this.thePageSize;
      return Math.min((p - 1) * s + 1, this.theTotal);
    },

    last() {
      const p = this.thePage;
      const s = this.thePageSize;
      return Math.min(p * s, this.theTotal);
    },

    oneItem() {
      return this.first === this.last;
    },

    showFiltersMsg(){
      return (this.showFilters? 'Ocultar': 'Exibir') + " filtros"
    }
  },

  methods: {
    onViewMode(v) {
      this.$emit("update:view-mode", v);
      this.showSettings = false;
    },

    onShowFiltersClick(){
      this.$emit("update:show-filters", !this.showFilters)
    },

  }
});
</script>
